/** 클릭 후 impression 발생까지의 지연(ms). AppsFlyer 권장값. */
export const FIRE_IMPRESSIONS_TIMEOUT = 1000

/** 정비소 상품 목록에서 노출되는 앱 다운로드 OneLink */
export const APP_DOWNLOAD_ONELINK_URL_IN_PRODUCT_LIST =
  'https://mycle.onelink.me/6370/hnqs7420'

/** 결제 완료 화면에서 노출되는 앱 다운로드 OneLink */
export const APP_DOWNLOAD_ONELINK_URL_IN_PAYMENT_SUCCESS =
  'https://mycle.onelink.me/6370/1uda2j0q'
